module.exports = __webpack_public_path__ + "img/background-login.ce18bc98.png";